import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationType as SchemaIntegrationType } from '../schemas/IntegrationType';
import { type Mapping as SchemaMapping } from '../schemas/Mapping';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const GetIntegrationMappingSettingsContentType = '' as const;
export type GetIntegrationMappingSettingsRequest = void;
export type GetIntegrationMappingSettingsResponses = LinkCommonErrorResponses & {
    /**
     * @description Mapping settings for integration
     */
    '200': {
        'application/json': SchemaMapping;
    };
};
export type GetIntegrationMappingSettingsResponseSuccess =
    GetIntegrationMappingSettingsResponses['200']['application/json'];
export type GetIntegrationMappingSettingsSearchParams = undefined;
export type GetIntegrationMappingSettingsPathParameters = {
    integration_type: SchemaIntegrationType;
};
export const GetIntegrationMappingSettingsUrl = '/integrations/settings/mapping/{integration_type}' as const;
export const GetIntegrationMappingSettingsMethod = 'GET' as const;
export const getGetIntegrationMappingSettingsUrl = (params: GetIntegrationMappingSettingsPathParameters) =>
    GetIntegrationMappingSettingsUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GetIntegrationMappingSettingsPathParameters) => String(params[param])
    );
